import coreUtilsLib from '@wix/santa-core-utils';

const { getFilter } = coreUtilsLib.svgFilters;
const { getMask } = coreUtilsLib.svgMask;
const { getCSSMask } = coreUtilsLib.svgMask;

export { getFilter, getMask, getCSSMask };
